import React from 'react'

import { 
    Auth 
} from 'aws-amplify'

import { 
    TopBackgroundDiv,
    BottomBackgroundDiv
} from '../Styles/BaseStyles'

import { 
    ComponentsDiv
} from '../Styles/Pages/AccountConfirmStyles'

import AccountConfirmDisp from '../Components/Display/AccountConfirmDisp'

import { useDispatch } from 'react-redux'

import { accountConfirmed, confirmationAccountError } from '../Redux/Slices/AccountConfirmSlice'

function AccountConfirm(props){

    const dispatch = useDispatch()

    async function confirmSignUp(username, code) { 
        try {
            await Auth.confirmSignUp(username, code)
            dispatch(accountConfirmed({email: username}))
        } catch (error) {
            if(error.name === 'ExpiredCodeException'){
                dispatch(confirmationAccountError({errorPhrase: 'Link has expired for verification.'}))
            }
            else if(error.name === 'NotAuthorizedException'){
                dispatch(confirmationAccountError({errorPhrase: 'Not authorized to verify account.'}))
            }
            else if(error.name === 'CodeMismatchException'){
                dispatch(confirmationAccountError({errorPhrase: 'Incorrect link for verification'}))
            }
        }
    }

    let username = props.match.params.username
    let code = props.match.params.code
    
    confirmSignUp(username,code)

    return (
        <>
            <TopBackgroundDiv />
            <BottomBackgroundDiv />
            <ComponentsDiv>
                <AccountConfirmDisp />
            </ComponentsDiv>
        </>
    )
}

export default AccountConfirm